
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import MicroModal from 'micromodal';

  @Component
  export default class NfcIdSet extends Vue {
    @Prop({ default: false }) readonly hasNfc!: boolean;
    @Prop({ default: false }) readonly nfcBuy!: boolean;
    @Prop({ default: () => {} }) readonly errors!: object;

    id: string = '';

    mounted() {
      this.id = `c${this._uid}`;
      MicroModal.init({
        awaitCloseAnimation: true,
      });

      setTimeout(() => {
        this.openOnboardModal();
      }, 1500);
    }

    hasError(fieldName: string) {
      return this.errors?.hasOwnProperty(fieldName);
    }

    registrationHandler() {
      this.$emit('update:nfcBuy', true);
    }

    setHasNfc() {
      this.$emit('update:hasNfc', true);
    }

    openOnboardModal() {
      MicroModal.show(`nfc-onboard-modal-${this.id}`);
    }

    closeModal() {
      MicroModal.close(`nfc-id-modal-${this.id}`);
      MicroModal.close(`nfc-onboard-modal-${this.id}`);
    }
  }
